function SignalCard({ label, value, dark = false }) {
  return (
    <article
      className={
        dark
          ? 'border-2 border-fd-ink bg-fd-ink p-6 text-fd-ivory shadow-document'
          : 'border border-fd-line bg-fd-paper p-6 text-fd-ink shadow-document'
      }
    >
      <p className={dark ? 'text-xs font-black uppercase tracking-[0.2em] text-fd-line' : 'text-xs font-black uppercase tracking-[0.2em] text-fd-stone'}>
        {label}
      </p>
      <p className="mt-3 font-serif text-xl font-black leading-tight">{value}</p>
    </article>
  );
}

export default SignalCard;
